// Whole-property systems (electrical, plumbing, geyser, etc.)
import {
  Zap, Droplet, Cpu, Flame, SunMedium, Layers, Grid3x3, ShieldCheck, Wrench,
} from "lucide-react";

export const SYSTEMS_CATEGORIES = [
  { key: "electrical",         label: "Electrical",          unit: "sqm",  baseRate: 180,   defaultQty: (sqm) => Math.max(60, Math.round(sqm)),   icon: Zap },
  { key: "plumbing",           label: "Plumbing",            unit: "sqm",  baseRate: 120,   defaultQty: (sqm) => Math.max(60, Math.round(sqm)),   icon: Droplet },
  { key: "db_board",           label: "DB Board",            unit: "item", baseRate: 2500,  defaultQty: 1,   icon: Cpu },
  {
    key: "geyser", label: "Hot Water / Geyser", unit: "item", baseRate: 4500,
    defaultQty: 1, icon: Flame,
    presets: [
      { label: "Electric geyser (150L)", rate: 800 },
      { label: "Electric geyser (200L)", rate: 1100 },
      { label: "Gas geyser",             rate: 1800 },
      { label: "Heat pump",              rate: 4500 },
      { label: "Solar geyser",           rate: 3500 },
    ],
  },
  {
    key: "solar_inverter", label: "Solar / Inverter", unit: "item", baseRate: 25000,
    defaultQty: 1, icon: SunMedium,
    presets: [
      { label: "3kW inverter + 5kWh battery",  rate: 9500 },
      { label: "5kW inverter + 10kWh battery", rate: 15500 },
      { label: "8kW inverter + 15kWh battery", rate: 24000 },
      { label: "Solar panels (per kW)",        rate: 1800 },
    ],
  },
  { key: "flooring_global",    label: "Flooring (global)",   unit: "sqm",  baseRate: 150,   defaultQty: (sqm) => Math.max(60, Math.round(sqm)),   icon: Layers },
  { key: "ceilings",           label: "Ceilings",            unit: "sqm",  baseRate: 85,    defaultQty: (sqm) => Math.max(60, Math.round(sqm)),   icon: Grid3x3 },
  { key: "waterproofing",      label: "Waterproofing",       unit: "sqm",  baseRate: 90,    defaultQty: (sqm) => Math.max(10, Math.round(sqm * 0.3)), icon: ShieldCheck },
  { key: "structural_repairs", label: "Structural Repairs",  unit: "item", baseRate: 8000,  defaultQty: 1,   icon: Wrench },
];

export { SCOPE_MULT, SCOPE_OPTIONS, CONDITION_OPTIONS } from "@/lib/exteriorTemplates";
